import { useState, useEffect } from "react";
import { fetchReviews } from "@/api/reviews";
import { errorToast } from "@/lib/toast";
import { useAuth } from "./use-auth";

export const useReviews = () => {
  const { astrologer } = useAuth();
  const [reviews, setReviews] = useState([]);
  const [featured, setFeatured] = useState(false);
  const [rating, setRating] = useState("");
  const [order, setOrder] = useState({ entity: "createdAt", sortBy: "desc" });
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const getReviews = async () => {
    setLoading(true);
    try {
      const { status, data } = await fetchReviews({
        astrologerId: astrologer.astrologerId,
        rating,
        featured,
        order,
        searchTerm,
        page: currentPage,
        limit: itemsPerPage,
      });
      if (status === 200) {
        setReviews(data.data?.reviews);
        setTotalItems(data.data?.pagination.totalDocuments);
      } else {
        errorToast("Failed to fetch reviews");
      }
    } catch (err) {
      errorToast("An error occurred while fetching reviews");
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = () => {
    setCurrentPage(1);
    getReviews();
  };

  // const clearFilters = () => {
  //   setRating("");
  //   setFeatured(false);
  //   setOrder({ entity: "createdAt", sortBy: "desc" });
  //   setSearchTerm("");
  //   setCurrentPage(1);
  //   getReviews();
  // };

  useEffect(() => {
    if (astrologer?.astrologerId) {
      setReviews([]);
      setCurrentPage(1);
      getReviews();
    }
  }, [astrologer?.astrologerId]);

  useEffect(() => {
    if (astrologer?.astrologerId) {
      getReviews();
      console.log(currentPage, itemsPerPage);
    }
  }, [currentPage, itemsPerPage]);

  return {
    reviews,
    loading,
    getReviews,
    rating,
    setRating,
    applyFilter,
    currentPage,
    setCurrentPage,
    totalItems,
    itemsPerPage,
    setItemsPerPage,
    featured,
    setFeatured,
    order,
    setOrder,
    searchTerm,
    setSearchTerm,
    // clearFilters,
  };
};
